export const INVALID_VALUE = -99999999;
export const PROCESSING_ROWS_THRESHOLD = 100; // Show Processing overlay when processing over 100 rows
export const DEBOUNCE_TIME = 500; // (In ms.) Debounce time for service calls to store balance sheet into DB
export const BALANCE_SHEET_CHECK_RATE = 10000; // (In ms.) Stored Balance Sheet Structure is checked periodically for a newer version
export const EMPTY_BOTTOM_ROWS = 2;
export const MINIMUM_ROWS = 50;

export const COL_CATEGORY = 0;
export const COL_ACCOUNT_NAME = 1;
export const COL_MNEMONIC = 2;
export const COL_ACCOUNT_NUMBER = 3;
export const COL_PARENT_ACC = 4;
export const COL_DISPLAY_ORDER = 5;
export const COL_FILTER_CRITERIA = 6;
